import { useState, useEffect } from "react";

const TERRAIN_BREAKPOINT = 768;

function getContext() {
  if (typeof window === "undefined") return { isTerrain: false, isBureau: true };
  const w = window.innerWidth;
  return { isTerrain: w <= TERRAIN_BREAKPOINT, isBureau: w > TERRAIN_BREAKPOINT };
}

export function useDeviceContext() {
  const [ctx, setCtx] = useState(getContext);

  useEffect(() => {
    let raf;
    const onResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setCtx(getContext()));
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return ctx;
}

export { TERRAIN_BREAKPOINT };
